module.exports = __webpack_public_path__ + "static/img/CumminsLogoTouMing.3bdd53c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CumminsLogoTouMing.png
// module id = cnDb
// module chunks = 1